module.exports = __webpack_public_path__ + "static/media/zibal.eec9f1ed.svg";